export enum ORDER_ACTION_TYPE {
  LIST = 'order/list',
  CREATE = 'order/create',
  SHOW = 'order/show',
}
